// extracted by extract-css-chunks-webpack-plugin
module.exports = {"need-help":"page-enter-details__need-help___4_x9o","needHelp":"page-enter-details__need-help___4_x9o","mobile-number-field":"page-enter-details__mobile-number-field___2j2I9","mobileNumberField":"page-enter-details__mobile-number-field___2j2I9"};
    if(module.hot) {
      // 1773353851028
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  